import React from 'react';

import Modal from 'components/Modal';
import TextButton from 'components/Button/TextButton';
import { ContainerMsg } from './styles';

function WhatsConfimationModal({
  isOpen, _setIsOpenWhatsConfModal, _setAction, params = {}, text,
}) {
  const sendMessage = (isSendWhats) => {
    _setAction({ ...params, isSendWhats });
    _setIsOpenWhatsConfModal(false);
  };

  return (
    <Modal
      padding="20px 15px 20px  15px"
      isOpen={isOpen}
      disabledCloseButton
      title="Enviar mensagem"
      textTransform="none"
      width="400px"
      textalingheader="left"
      toggle={() => _setIsOpenWhatsConfModal(false)}
    >
      <ContainerMsg>
        {text}
      </ContainerMsg>
      <TextButton onClick={() => sendMessage(true)}>Sim</TextButton>
      <TextButton onClick={() => sendMessage(false)}>Não</TextButton>
    </Modal>
  );
}

export default WhatsConfimationModal;
